export const PlayerErrorMessages = {
  BROWSER_AUTOPLAY_PROHIBITED: [
    'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission',
    'play() can only be initiated by a user gesture',
  ],
} as const;

export const ListenRejectedReasons = {
  PLAN_USED_UP: 'PLAN_USED_UP',
  PLAN_EXPIRED: 'PLAN_EXPIRED',
  PREMIUM_LOCKED: 'PREMIUM_LOCKED',
  ETHICS_LOCKED: 'ETHICS_LOCKED',
  NOT_LOGGED_IN: 'NOT_LOGGED_IN',
  UNKNOWN: 'UNKNOWN',
  NEED_REDEEM: 'NEED_REDEEM',
  FREE_TRIAL_ENDED: 'FREE_TRIAL_ENDED',
} as const;

export type ListenRejectedReason =
  (typeof ListenRejectedReasons)[keyof typeof ListenRejectedReasons];

export const CPDPlayerListenRejectedReasons = {
  ETHICS_LOCKED: 'lumiq.cpd.auth.restricted_content.ethics',
  PREMIUM_LOCKED: 'lumiq.cpd.auth.restricted_content.premium',
} as const;

export type CPDPlayerListenRejectedReason =
  (typeof CPDPlayerListenRejectedReasons)[keyof typeof CPDPlayerListenRejectedReasons];

export const CPEPlayerListenRejectedReasons = {
  ETHICS_LOCKED: 'lumiq.cpe.auth.restricted_content.ethics',
  PREMIUM_LOCKED: 'lumiq.cpe.auth.restricted_content.premium',
  NEED_REDEEM: 'lumiq.cpe.auth.requires_claim',
} as const;

export type CPEPlayerListenRejectedReason =
  (typeof CPEPlayerListenRejectedReasons)[keyof typeof CPEPlayerListenRejectedReasons];

export type ApiListenRejectedReason =
  | CPDPlayerListenRejectedReason
  | CPEPlayerListenRejectedReason;

export const ApiListenRejectedReasonToListenRejectedReason = {
  [CPDPlayerListenRejectedReasons.ETHICS_LOCKED]:
    ListenRejectedReasons.ETHICS_LOCKED,
  [CPDPlayerListenRejectedReasons.PREMIUM_LOCKED]:
    ListenRejectedReasons.PREMIUM_LOCKED,
  [CPEPlayerListenRejectedReasons.ETHICS_LOCKED]:
    ListenRejectedReasons.ETHICS_LOCKED,
  [CPEPlayerListenRejectedReasons.PREMIUM_LOCKED]:
    ListenRejectedReasons.PREMIUM_LOCKED,
  [CPEPlayerListenRejectedReasons.NEED_REDEEM]:
    ListenRejectedReasons.NEED_REDEEM,
} as const;

export const PlaybackErrors = {
  CONCURRENT_SESSION:
    'lumiq.player.playback_regulated.concurrent_session_detected',
  PLAY_NOT_AUTHORIZED: 'event (play) is not authorized',
};

export const AnswerQuizApiErrorMessages = {
  'lumiq.answer_quiz.redemption_not_found': 'Redemption not found',
  'lumiq.plan.redeem.exceeds_member_cap': 'Member usage cap exceeded',
  'lumiq.plan.redeem.plan_expired': 'Plan expired',
  'lumiq.answer_quiz.chapter_state_not_quiz_ready':
    'Chapter state not quiz ready',
};

export const PlayerConfigs = {
  SESSION_MODEL: 'session_model',
  LEGACY: 'legacy',
} as const;

export const SessionTypes = {
  CPD: 'cpd_fsm',
  CPE: 'cpe_fsm',
} as const;

export const PLAYER_FORWARD_30 = 30;
export const PLAYER_REPLAY_30 = -30;
export const PLAYER_START_TIME = 0;
export const DEFAULT_AUTO_SAVE_INTERVAL = 5;
export const DEFAULT_PLAYBACK_SPEED_OPTIONS = [1];

export const PLAYER_POSITION_REGEX = /\(([0-9]+)s\)/;
